@if (state()?.isLoading) {
  <app-edit-form-skeleton />
} @else {
  @if (state()?.data; as data) {
    <form class="flex flex-col gap-8" (submit.prevent)="onSubmit()" autocomplete="off">
      <div class="flex items-center">
        <div class="flex flex-col flex-1">
          <h3 class="text-on-surface dark:text-on-surface-darkmode font-semibold">
            {{ 'cockpit.settings.address.title' | transloco }}
          </h3>
          <p class="text-sm text-on-surface-variant dark:text-on-surface-variant-darkmode">
            {{ 'cockpit.settings.address.description' | transloco }}
          </p>
        </div>
        <div class="flex-none flex gap-2 items-center">
          <ui-button
            class="hidden sm:inline"
            [loading]="isUpdateLoading()"
            [disabled]="isUpdateLoading() || !form()?.dirty()"
            type="submit"
          >
            <ng-icon name="heroCheck" size="20" slot="start" class="!block" />
            {{ 'cockpit.settings.address.saveButton' | transloco }}
          </ui-button>
        </div>
      </div>

      <div class="empty:hidden text-end">
        @if (showValidationErrors() && form()?.invalid()) {
          <ui-input-error>
            {{ 'cockpit.settings.address.validationError' | transloco }}
          </ui-input-error>
        }

        @if (updateError()) {
          <ui-input-error>
            {{ 'cockpit.settings.address.updateError' | transloco }}
          </ui-input-error>
        }
      </div>

      <app-organization-create-address-form [organization]="data" />
    </form>
  }
}
